(function () {

function forcePlay(video) {
  if (!video) return;

  video.muted = true;
  video.setAttribute('muted', '');
  video.setAttribute('autoplay', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('loop', '');

  video.playsInline = true;
  video.autoplay = true;
  video.loop = true;

  video.removeAttribute('controls');

  // 🚨 KEY: ensure it's not stuck on poster
  if (video.paused) {
    video.currentTime = 0;
  }

  if (video.readyState < 2) {
    video.load();
  }

  video.play().catch(function () {
    setTimeout(function () {
      video.play().catch(function () {});
    }, 300);
  });
}

function handleContainer(container) {
  if (!container) return;

  container.querySelectorAll('deferred-media').forEach(function (dm) {
    // ✅ Horizon-compatible way
    if (typeof dm.loadContent === 'function') {
      dm.loadContent();
    } else {
      // fallback for older themes
      var btn = dm.querySelector('[ref="deferredMediaPlayButton"]');
      if (btn) btn.click();
    }
  });

  // Wait until video is ACTUALLY injected
  var tries = 0;

  var interval = setInterval(function () {
    var videos = container.querySelectorAll('video');

    if (videos.length) {
      videos.forEach(forcePlay);
      clearInterval(interval);
    }

    if (++tries > 25) {
      clearInterval(interval);
    }
  }, 200);
}

  function getOpenModal() {
    return document.querySelector(
      'dialog[open], .quick-add-modal[open], .product-modal[open], dialog.is-active, .modal.is-active'
    );
  }

  /**
   * MAIN TRIGGER (user interaction required for autoplay)
   */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '[data-quick-add], .quick-add__submit, .card__quick-add-button, .product-card__quick-add'
    );

    if (!trigger) return;

    // Wait for Horizon to inject modal + content
    setTimeout(function () {
      var modal = getOpenModal();

      if (!modal) return;

      handleContainer(modal);

      // Watch ONLY this modal for new content
      var observer = new MutationObserver(function () {
        handleContainer(modal);
      });

      observer.observe(modal, {
        childList: true,
        subtree: true
      });

      // Clean up when modal closes
      var cleanup = setInterval(function () {
        if (!document.body.contains(modal) || !modal.open) {
          observer.disconnect();
          clearInterval(cleanup);
        }
      }, 500);

    }, 600); // Horizon needs a bit more time
  });

  /**
   * Fallback for normal product pages
   */
  document.addEventListener('DOMContentLoaded', function () {
    handleContainer(document);
  });

})();